<template>
  <div v-if="logList.length > 0" class="update-logs-card">
    <div class="main">
      <div class="headline">
        <div class="main-title">{{ $t("download.updateLog") }}</div>
        <div
          :class="['collapse-icon', 'no-select', isCollapse ? 'rotate180' : '']"
          @click="isCollapse = !isCollapse"
        >
          <img src="@/assets/image/icon/more.png" alt="" />
        </div>
      </div>
      <div
        class="collapse-content"
        :style="{ height: isCollapse ? '0px' : logHeight }"
      >
        <ul ref="logoRef" class="logo-list">
          <li v-for="(item, index) in logList" :key="index" class="log-item">
            <div class="title">{{ item.title }}</div>
            <div class="time">{{ $t("document.updateTime") }}：{{ item.updateTime }}</div>
            <div class="update-content" v-html="item.contentDetail"></div>
          </li>
        </ul>
      </div>
    </div>
    <div class="loading" v-if="isLoading === 1">正在加载中...</div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, nextTick } from "vue";
import { getResLogApi } from "@/api/developer";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const logoRef = ref(null);
const isCollapse = ref(false);
const logHeight = ref("auto");

const props = defineProps({
  logList: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Number,
    default: 0,
  },
});

watch(
  () => props.logList,
  () => {
    logHeight.value = "auto";
    nextTick(() => {
      logHeight.value = logoRef.value?.offsetHeight + "px";
    });
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped>
.update-logs-card {
  background: #ffffff;
  border-radius: 4px;
  caret-color: transparent;
  position: relative;
  ul,
  li {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .loading {
    width: 100%;
    position: absolute;
    bottom: -24px;
    text-align: center;
    text-align: center;
    font-size: 14px;
    color: #333333;
    opacity: 0.4;
  }
  .main {
    padding: 0 24px 0;
    .headline {
      padding: 24px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .main-title {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
        line-height: 33.6px;
        text-align: left;
      }
      .collapse-icon {
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: transform linear 0.3s;

        img {
          width: 100%;
          height: auto;
        }
      }
      .rotate180 {
        transform: rotate(-180deg);
      }
    }
    .collapse-content {
      transition-property: height;
      transition-duration: 0.3s;
      will-change: height;
      .logo-list {
        height: 100%;
        overflow: hidden;
        .log-item {
          padding: 32px 0;
          border-top: 0.5px solid #e9e9e9;
          .title {
            font-size: 18px;
            font-weight: bold;
            line-height: 40px;
            text-align: left;
            color: #333333;
          }
          .time {
            margin-top: 2px;
            font-size: 12px;
            line-height: 16.8px;
            text-align: left;
            color: #666666;
          }
          .update-content {
            opacity: 0.8;
            font-size: 14px;
            line-height: 28px;
            text-align: left;
            color: #333333;
            margin-top: 16px;
            white-space: pre-wrap;
            word-break: break-word;
          }
          &:first-child {
            border-top: 0;
            padding: 0 0 36px;
          }
        }
      }
    }
  }
}
</style>
